import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

export default {
  state: {
    credentialTypes: {
      ID: '身份证',
      PASSPORT: '护照',
      EEP: '港澳台通行证',
      MTP: '台胞证'
    },
    bcv_id: null,
    coupons: [],
    discount_amount: {},
    discount_recommend: null,
    orderId: null,
    order_flags: null,
    payCountDown: -1,
    performs: [],
    pickupOrder: null,
    status: null,
    user: [],
    totalAmount: null,
    showLocation: true,
    announce: [],
    checkoutEvent: {},
    venuesTitle: '',
    venuesAddress: ''
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/order/index.js